import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Apollo imports
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';

// Apollo client setup
const client = new ApolloClient({
  uri: 'http://localhost:4000/graphql', // your backend URL
  cache: new InMemoryCache(),
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>
);

reportWebVitals();
